import React from 'react';

const ViewPanelContext = React.createContext(null);
export default ViewPanelContext;
